import type { FeedbackMetadataSnapshot } from "./feedbackContracts.js";

/** Non-destructive interpretation of old collector badges. Never rewrite the
 * immutable report merely because today's interpreter knows more fields. */
export function feedbackCoverage(metadata: FeedbackMetadataSnapshot) {
  const audio = metadata.audio;
  const voice = audio.voice;
  const missing = [...(metadata.collectors.audio.missing ?? [])];
  if (!audio.narrationSource || audio.narrationSource === "unavailable")
    missing.push("Realized narration was not captured");
  if (
    !voice ||
    typeof voice !== "object" ||
    Array.isArray(voice) ||
    !voice.voiceId
  )
    missing.push("Voice identity was not captured");
  if (
    !Array.isArray(audio.activeVoiceoverCues) ||
    !audio.activeVoiceoverCues.length
  )
    missing.push(
      "No active narration cue is recorded at this timestamp; silence is not established",
    );
  return {
    schemaVersion: "feedback-coverage-interpretation.v1",
    originalStatus: metadata.status,
    audio: {
      status: missing.length ? "partial" : metadata.collectors.audio.status,
      missing: [...new Set(missing)],
    },
    timeline: {
      basis: metadata.timeline.source ?? "unavailable",
      outputBinding: "unverified",
      note: "Authored timing does not establish the delivered frame or current remake.",
    },
  };
}
